import { ComponentDesign, Lumber, LumberList, OrganizationMaterialSet } from '@paragon/contract-library';

import { getLumberCode, lumbersAreEqual } from './lumberIdentity';

const defaultStockLengths = [2 * 12, 4 * 12, 6 * 12, 8 * 12, 10 * 12, 12 * 12, 14 * 12, 16 * 12];

export class ComponentMaterialStockLengths {
  private materials: OrganizationMaterialSet;
  private lumberListMap: Map<string, string> = new Map<string, string>();
  private stockLengthsCache: Map<string, number[]> = new Map<string, number[]>();

  constructor(componentDesigns: readonly ComponentDesign[], materials: OrganizationMaterialSet) {
    this.materials = materials;

    for (const { guid, materialSelection } of componentDesigns) {
      if (materialSelection?.lumberListGuid && materialSelection.lumberListGuid in materials.lumberLists) {
        this.lumberListMap.set(guid, materialSelection.lumberListGuid);
      }
    }
  }

  getStockLengths(componentDesign: ComponentDesign, lumber: Lumber): number[] | null {
    const cacheKey = this.getCacheKey(componentDesign, lumber);
    if (this.stockLengthsCache.has(cacheKey)) {
      return this.stockLengthsCache.get(cacheKey)!;
    }

    const resultSet = new Set<number>();

    const lumberList = this.getLumberList(componentDesign.guid);
    if (!lumberList) return defaultStockLengths;

    for (const stockLumber of lumberList.stockLumbers) {
      if (lumbersAreEqual(stockLumber.lumber, lumber)) {
        for (const stockLength of stockLumber.stockLengths) {
          resultSet.add(stockLength);
        }
      }
    }

    const result = Array.from(resultSet);
    this.stockLengthsCache.set(cacheKey, result);

    return result;
  }

  private getLumberList(componentDesignGuid: string): LumberList | null {
    const lumberListErrorMessage = `Unable to get lumber list for ${componentDesignGuid}`;

    const lumberListGuid = this.lumberListMap.get(componentDesignGuid);
    if (!lumberListGuid) return null; // The inventory set may be external

    const lumberList = this.materials.lumberLists[lumberListGuid];
    if (!lumberList) throw new Error(lumberListErrorMessage);

    return lumberList;
  }

  private getCacheKey(componentDesign: ComponentDesign, lumber: Lumber) {
    const componentDesignKey = componentDesign.guid;
    const lumberKey = getLumberCode(lumber);

    return `${componentDesignKey}-${lumberKey}`;
  }
}
